import { put } from 'redux-saga/effects'
import { crudGetSimple } from '@/state/actions/data'

// Here we would do checks for existing data and load whatever we need for this view. Also manage
// generic tasks such as showing/hiding loaders based on UI needs.
export default function* loadStatistics(action) {
  yield put(crudGetSimple('statistics', true))
}



// WEBPACK FOOTER //
// ./state/sagas/statistics.js